var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.865,
    height: 12.913,
    viewBox: "0 0 12.865 12.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a8a8a8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.39,10.176,11.265,8.051a5.863,5.863,0,0,0,.644-2.576,5.475,5.475,0,1,0-5.475,5.475,5.863,5.863,0,0,0,2.576-.644l2.125,2.125a1.556,1.556,0,0,0,2.254,0A1.678,1.678,0,0,0,13.39,10.176ZM6.435,9.661a4.186,4.186,0,1,1,4.186-4.186A4.178,4.178,0,0,1,6.435,9.661Z",
    transform: "translate(-0.96)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.04a962c469f3c063abd3b7c8907eea9b.svg";
export { ForwardRef as ReactComponent };